import React from 'react';

const AdminProductScreen = () => {
  return <div>AdminProductScreen</div>;
};

export default AdminProductScreen;
